import LogRocket from "logrocket";
import { PropsWithChildren, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import srcSpinner from "../../assets/images/blue-spinner.gif";
import WebViewClient from "../../backend/clients/WebViewClient";
import normalizeError from "../../utils/errors";
import { useServiceWorkerContext } from "../ServiceWorkerContext/ServiceWorkerContext";

import { Tool, ToolContext, ToolContextState } from "./ToolContext";

const Loader = styled.img`
  width: 100px;
  height: 100px;
`;

const Center = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ToolProvider = ({ children }: PropsWithChildren<unknown>) => {
  const sw = useServiceWorkerContext();
  const [context, setContext] = useState<ToolContextState | undefined>(
    undefined,
  );

  const { t } = useTranslation();

  useEffect(() => {
    const handleSetContext = async (context: ToolContextState) => {
      if (context.tool === Tool.LutronDesigner) {
        try {
          await sw.register();
        } catch (error) {
          LogRocket.captureException(
            normalizeError(error, new Error("service worker registration")),
          );
        }
      }

      setContext(context);
    };

    return WebViewClient.registerSetContextListener(handleSetContext);
  }, [sw]);

  if (context === undefined) {
    return (
      <Center>
        <Loader src={srcSpinner} alt={t("loading")} />
      </Center>
    );
  }

  return (
    <ToolContext.Provider value={context}>{children}</ToolContext.Provider>
  );
};

export default ToolProvider;
